<template>
    <div class="nonedata-box">
        <img class="img-none" src="@/assets/none.png" />
    </div>
</template>
<script>
export default {
    name:"NoneData",
}
</script>
<style lang="less" scoped>
.nonedata-box{
    position: relative;
    width: 100%;
    margin-top:88px;
    margin-bottom: 80px;
    text-align: center;
    .img-none{
        width: 140px;
        height: 130px;
    }
}
</style>